import React, { useEffect } from 'react';

import Loading from 'Components/Utility/Loading';
import linkEpic from 'Redux/ducks/epic';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';
import { history } from 'Redux/store';

function EpicReturnContainer() {
  useEffect(() => {
    const defaultUrl = '/account';
    const redirectUrl = localStorage.getItem('epicRedirect') || defaultUrl;
    localStorage.removeItem('epicRedirect');

    const doLinkEpic = async (code, state) => linkEpic(code, state).then(() => {
      history.push(redirectUrl);
    }).catch(() => {
      history.push(`${redirectUrl}?message=${'No Epic authorization code, please try again'}`);
    });

    if (getUrlParameter('code')) {
      doLinkEpic(getUrlParameter('code'), getUrlParameter('state'));
    } else {
      history.push(`${defaultUrl}?message=${'No Epic authorization code, please try again'}`);
    }
  }, []);

  return (
    <React.Fragment>
      <Loading />
    </React.Fragment>
  );
}

export default EpicReturnContainer;
